import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "BatteryHalf"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 18H4.5C3.67157 18 3 17.3284 3 16.5V7.5C3 6.67157 3.67157 6 4.5 6H18C18.8284 6 19.5 6.67157 19.5 7.5V8.25H20.25C21.0784 8.25 21.75 8.92157 21.75 9.75V14.25C21.75 15.0784 21.0784 15.75 20.25 15.75H19.5V16.5C19.5 17.3284 18.8284 18 18 18ZM12 9V15H6V9H12ZM4.5 16.5V7.5H18V9.75H20.25V14.25H18V16.5H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/BatteryHalf.vue"]]);
